module.exports = __webpack_public_path__ + "img/logo--heidiland-invert.a5dd080e.svg";